import { PressableBase, type PressableSkin } from './pressable.shared';
import type { PressableProps } from './types';

const SKIN: PressableSkin = {
  rounded: {
    card: 'rounded-xl',
    default: 'rounded-sm',
    flush: 'rounded-none',
  },
  interaction:
    'focus:outline-hidden focus-visible:ring-2 focus-visible:ring-spark-purple focus-visible:ring-offset-2 enabled:hover:bg-gray-100 disabled:cursor-not-allowed',
};

export function Pressable(props: PressableProps) {
  return <PressableBase {...props} skin={SKIN} />;
}
